import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { palette } from '../../../../system/styles/styles';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Tooltip } from '@material-ui/core';
import { Send } from 'styled-icons/feather';
import { useSelector } from 'react-redux';

const ContainerTranfer = styled.main`
  width: calc(100% - 30px);
  padding: 15px;
  section {
    //margin-top: 20px;
    height: 50px;
    position: relative;
    &:nth-child(1) {
      //display: grid;
      //grid-template-columns: 40% 60%;
      align-items: center;

      .icon {
        //width: 2vh;
        height: 25px;
        color: #ffffff;
        cursor: pointer;
        color: ${palette.lightBlue};
        margin-left: 20px;
      }

      .bxItem {
        width: 100%;
        height: 100%;
        display: flex;
        margin: 10px 0;

        label.active {
          background-color: ${palette.lightpurple};
          color: ${palette.purple};
        }

        label {
          width: 100%;
          height: 100%;
          text-align: center;
          display: grid;
          align-content: center;
          font-family: ${palette.nereg};
          font-size: 14px;
          background-color: ${palette.white};
          border: 1px solid ${palette.lightpurple};
          cursor: pointer;

          &:nth-child(1) {
            //border-radius: 10px 0 0 10px;
            border-radius: 10px;
          }

          &:nth-child(2) {
            border-radius: 0 10px 10px 0;
          }
        }
      }
    }

    .secondSection {
      display: grid;
      grid-template-columns: 40% 60%;

      .formControl {
        //border-bottom: 1px solid #000;
        display: flex;
        flex-direction: row;
        width: 100%;
        align-self: center;
      }

      .filter {
        width: 20vw;
        border: none;
        position: relative;
      }

      .iconFil {
        color: rgba(76, 88, 102, 0.4);
        align-self: center;
        position: absolute;
        width: 2vw;
      }
    }
  }

  .tableListMain {
    .justifySelfCenter {
      justify-self: center;
    }

    .tableList {
      margin-top: 40px;
      width: 100%;
      overflow: auto;
      display: flex;
      flex-direction: column;

      thead {
        display: grid;
        grid-template-columns: 30% 30% 40%;
        width: 100%;
        border-bottom: 1px solid rgba(76, 88, 102, 0.4);

        td {
          padding: 10px 0;
          font-family: ${palette.nereg};
          font-size: 14px;
          color: rgba(76, 88, 102, 0.4);
        }
      }

      tbody {
        &::-webkit-scrollbar {
          width: 1em;
          height: 0.8em;
        }

        &::-webkit-scrollbar-track {
          background-color: #f2f2f2;
        }

        &::-webkit-scrollbar-thumb {
          background-color: #ccc;
          border-radius: 0.8rem;
        }

        overflow-y: auto;
        height: calc(60vh - 40px - 39px);

        tr {
          display: grid;
          grid-template-columns: 30% 30% 40%;
          width: 100%;
          padding: 15px 0;
          border-bottom: 2px solid rgba(76, 88, 102, 0.4);
          position: relative;
          td {
            font-family: ${palette.nereg};
            font-size: 14px;
            position: relative;
            .icon {
              width: 20px;
              cursor: pointer;
              top: 50%;
              left: 50%;
              transform: translateY(-50%) translateX(-50%);
            }
          }

          .type {
            background-color: ${palette.blue};
            color: #ffffff;
            width: 50%;
            border-radius: 10px;
            text-align: center;
            text-transform: capitalize;
          }

          &:hover {
            background-color: rgba(76, 88, 102, 0.1);
          }
        }
      }
    }
  }
`;

const TraferirStep = (props) => {
  const { jobs, onClick_Transfer } = props;
  const { t } = useTranslation(['applicant']);
  const [tab, setTab] = React.useState(0);
  const store = useSelector((state) => state?.vacancies);
  const [jobsTemp, setJobsTemp] = React.useState([]);
  const viewVacancies = () => {
    const storeTemp = JSON.parse(JSON.stringify(store));
    console.log(storeTemp);
    const arrayJobs = [];
    storeTemp
      .filter((e) => e.Status === true)
      .map((o) => {
        arrayJobs.push(
          <tr>
            <td>{o.jobTitle}</td>
            <td>{o.createdAt ? moment(o.createdAt).format('DD-MM-YYYY') : 'N/A'}</td>
            <Tooltip title={tab === 0 ? t('tooltipTransfer2') : t('tooltipInvite2')} arrow>
              <td
                className="justifySelfCenter"
                onClick={() => {
                  console.log('SECOND transfer');
                  onClick_Transfer(o);
                }}>
                <Send className="icon" />
              </td>
            </Tooltip>
          </tr>
        );
        return null;
      });
    setJobsTemp(arrayJobs);
  };

  React.useEffect(() => {
    viewVacancies();
  }, [store, tab]);

  return (
    <ContainerTranfer>
      <section>
        <article className="bxItem">
          <Tooltip title={tab === 0 ? t('tooltipTransfer1') : t('tooltipInvite1')}>
            <label className={tab === 0 ? 'active' : ''} onClick={() => setTab(0)}>
              {t('Transfer')}
            </label>
          </Tooltip>

          {/*<label className={tab === 1 ? 'active' : ''} onClick={() => setTab(1)}>*/}
          {/*  {t('Invite')}*/}
          {/*</label>*/}
        </article>
        {/*<Tooltip title={tab === 0 ? t('tooltipTransfer1') : t('tooltipInvite1')}>*/}
        {/*  <InfoCircle className="icon" />*/}
        {/*</Tooltip>*/}
      </section>

      <section className="tableListMain">
        <table className="tableList">
          <thead>
            <td>{t('Vacancies')}</td>
            <td>{t('PostDate')}</td>
            <td className="justifySelfCenter">{t('Actions')}</td>
          </thead>

          <tbody>{jobsTemp}</tbody>
        </table>
      </section>
    </ContainerTranfer>
  );
};

TraferirStep.propTypes = {
  jobs: PropTypes.arrayOf(PropTypes.object),
  // eslint-disable-next-line react/forbid-prop-types
  info: PropTypes.object,
  onClick_Transfer: PropTypes.func,
};

TraferirStep.defaultProps = {
  jobs: [],
  info: {},
  onClick_Transfer: () => {},
};

export default TraferirStep;
